<template>
  <PageWrapper :isLoading="isLoading">
    <template #title> ویرایش گروه </template>
    <BRow v-if="defaultPriceCategory">
      <!-- Title -->
      <BCol cols="12" md="6">
        <BFormGroup label="عنوان گروه" label-for="title">
          <BFormInput
            :state="titleState"
            v-model="defaultPriceCategory.title"
            id="title"
            trim
            placeholder="برای مثال بحث آزاد"
          />
          <BFormInvalidFeedback id="input-live-feedback">
            {{ titleError }}
          </BFormInvalidFeedback>
        </BFormGroup>
      </BCol>

      <!-- Duration -->
      <BCol cols="12" md="6">
        <BFormGroup
          label="مدت زمان هر جلسه (بین 10 تا 120 دقیقه)"
          label-for="duration"
        >
          <BFormInput
            :state="durationState"
            v-model.number="defaultPriceCategory.duration"
            id="duration"
            trim
            type="number"
            placeholder="40"
          />
          <BFormInvalidFeedback id="input-live-feedback">
            {{ durationError }}
          </BFormInvalidFeedback>
        </BFormGroup>
      </BCol>

      <!-- Min Duration -->
      <BCol cols="12" md="6">
        <BFormGroup
          label="حداقل زمان رزرو برای این گروه بندی"
          label-for="minDuration"
        >
          <BFormInput
            v-model.number="defaultPriceCategory.minDuration"
            id="minDuration"
            trim
            type="number"
            placeholder="60"
          />
        </BFormGroup>
      </BCol>

      <!-- User Price -->
      <BCol cols="12" md="6">
        <BFormGroup
          label="قیمت پایه برای هر جلسه کاربر (تومان)"
          label-for="userPrice"
        >
          <BFormInput
            :state="userPriceState"
            v-model.number="defaultPriceCategory.userPrice"
            id="userPrice"
            trim
            type="number"
            placeholder="120000"
          />
          <BFormInvalidFeedback id="input-live-feedback">
            {{ userPriceError }}
          </BFormInvalidFeedback>
        </BFormGroup>
      </BCol>

      <!-- Master Price -->
      <BCol cols="12" md="6">
        <BFormGroup
          label="قیمت پایه برای هر جلسه استاد (تومان)"
          label-for="masterPrice"
        >
          <BFormInput
            :state="masterPriceState"
            v-model.number="defaultPriceCategory.masterPrice"
            id="masterPrice"
            trim
            type="number"
            placeholder="80000"
          />
          <BFormInvalidFeedback id="input-live-feedback">
            {{ masterPriceError }}
          </BFormInvalidFeedback>
        </BFormGroup>
      </BCol>

      <!-- Vip User Price -->
      <BCol cols="12" md="6">
        <BFormGroup
          label="قیمت پایه برای هر جلسه VIP کاربر (تومان)"
          label-for="userVipPrice"
        >
          <BFormInput
            :state="userVipPriceState"
            v-model.number="defaultPriceCategory.vipUserBasePaymentPrice"
            id="userVipPrice"
            trim
            type="number"
            placeholder="120000"
          />
          <BFormInvalidFeedback id="input-live-feedback">
            {{ userVipPriceError }}
          </BFormInvalidFeedback>
        </BFormGroup>
      </BCol>

      <!-- Vip Master Price -->
      <BCol cols="12" md="6">
        <BFormGroup
          label="قیمت پایه برای هر جلسه VIP استاد (تومان)"
          label-for="masterVipPrice"
        >
          <BFormInput
            :state="masterVipPriceState"
            v-model.number="defaultPriceCategory.vipMasterBasePaymentPrice"
            id="masterVipPrice"
            trim
            type="number"
            placeholder="120000"
          />
          <BFormInvalidFeedback id="input-live-feedback">
            {{ masterVipPriceError }}
          </BFormInvalidFeedback>
        </BFormGroup>
      </BCol>

      <!-- Language Picker -->
      <BCol cols="12" md="6">
        <LanguagePicker
          :defaultLanguageId="defaultPriceCategory.langId"
          @getLanguage="setLanguage"
        ></LanguagePicker>
      </BCol>

      <!-- Shared Price Category Ids -->
      <BCol cols="12" md="6">
        <BFormGroup
          label="گروه‌بندی های مشترک در غیبت"
          label-for="sharedPriceCategories"
        >
          <PriceCategoryPicker
            id="sharedPriceCategories"
            :isMultiple="true"
            :isRenderingLabel="false"
            :defaultPriceCategoryIds="defaultPriceCategory.priceCategoryIds"
            @getPriceCategory="setPriceCategoryIds"
          ></PriceCategoryPicker>
        </BFormGroup>
      </BCol>

      <!-- DSD-662	 -->

      <!-- DaysLimit -->
      <!-- <BCol cols="12" md="6">
        <DaysLimitPicker
          :defaultSelectedDays="defaultPriceCategory.daysLimit"
          v-model="defaultPriceCategory.daysLimit"
        ></DaysLimitPicker>
      </BCol> -->

      <!-- Master Picker -->
      <BCol cols="12">
        <MasterPicker
          :isMultiple="true"
          :defaultSelectedMaster="previouslyExistingUsers"
          @getMaster="setMasters"
        ></MasterPicker>
      </BCol>

      <!-- Description -->
      <BCol cols="12">
        <BFormGroup
          :state="descriptionState"
          label="توضیحات گروه"
          label-for="description"
        >
          <BFormTextarea
            :state="descriptionState"
            placeholder="توضیحات گروه‌بندی"
            id="description"
            trim
            v-model="defaultPriceCategory.description"
          ></BFormTextarea>
          <BFormInvalidFeedback id="input-live-feedback">
            {{ descriptionError }}
          </BFormInvalidFeedback>
        </BFormGroup>
      </BCol>
      <!-- Has Penalty -->
      <BCol cols="12" md="6">
        <BFormCheckbox
          v-model="defaultPriceCategory.hasPenalty"
          name="check-button"
          switch
        >
          <small style="margin-left: 3px">آیا این گروه‌بندی جریمه دارد؟</small>

          <b>({{ defaultPriceCategory.hasPenalty ? "بله" : "خیر" }})</b>
        </BFormCheckbox>
      </BCol>

      <!-- isFreeFromLesson -->

      <BCol cols="12" md="6">
        <BFormCheckbox
          v-model="defaultPriceCategory.isFreeFromLesson"
          name="check-button"
          switch
        >
          <small style="margin-left: 3px"
            >آیا این گروه‌بندی
            <b> بدون </b>
            درس خواهد بود؟</small
          >

          <b>({{ defaultPriceCategory.isFreeFromLesson ? "بله" : "خیر" }})</b>
        </BFormCheckbox>
      </BCol>

      <!-- isPrivate -->

      <BCol cols="12" md="6">
        <BFormCheckbox
          v-model="defaultPriceCategory.isPrivate"
          name="check-button"
          switch
        >
            <small style="margin-left: 3px">آیا این گروه‌بندی خصوصی است؟</small>

          <b>({{ defaultPriceCategory.isPrivate ? "بله" : "خیر" }})</b>
        </BFormCheckbox>
      </BCol>
    </BRow>
    <BRow>
      <BCol cols="12" class="d-flex align-items-center justify-content-end">
        <BButton
          @click="sendCategoryPriceUpdateRequest"
          :disabled="isSubmitButtonDisabled"
          variant="success"
        >
          ویرایش
        </BButton>
      </BCol>
    </BRow>
  </PageWrapper>
</template>

<script>
export default {
  mounted() {
    this.getASinglePriceCategory();
    this.getPriceCategoryMasters();
  },
  data() {
    return {
      isLoading: false,
      defaultPriceCategory: null,
      usersReadyToAddToPriceCategory: [],
      previouslyExistingUsers: null,
    };
  },
  methods: {
    setPriceCategoryIds(priceCategoryIds) {
      this.defaultPriceCategory.priceCategoryIds = priceCategoryIds;
    },
    setMasters(mastersList) {
      this.usersReadyToAddToPriceCategory = mastersList;
    },
    async getPriceCategoryMasters() {
      try {
        this.isLoading = true;
        let _this = this;
        let getPriceCategoryUsers = new GetPriceCategoryUsers(_this);
        getPriceCategoryUsers.setRequestParam({
          id: _this.$route.params.id,
        });
        await getPriceCategoryUsers.fetch((response) => {
          _this.previouslyExistingUsers = response.userIds;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async addNewUsersToThisPriceCategory() {
      try {
        this.isLoading = true;
        let _this = this;
        let addUserToPriceCategory = new AddUserToPriceCategory(_this);
        addUserToPriceCategory.setRequestParamDataObj({
          priceCategtoryId: _this.$route.params.id,
          userIds: _this.usersReadyToAddToPriceCategory.map(
            (master) => master.userId
          ),
        });
        await addUserToPriceCategory.fetch((response) => {});
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    setDaysLimit(daysLimit) {
      this.defaultPriceCategory.daysLimit = daysLimit;
    },
    setLanguage(langId) {
      this.defaultPriceCategory.langId = langId;
    },
    async getASinglePriceCategory() {
      try {
        this.isLoading = true;
        let _this = this;
        let getASinglePriceCategory = new GetASinglePriceCategory(_this);
        getASinglePriceCategory.setRequestParam({ id: _this.$route.params.id });
        await getASinglePriceCategory.fetch((res) => {
          _this.defaultPriceCategory = res;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async sendCategoryPriceUpdateRequest() {
      await this.addNewUsersToThisPriceCategory();
      try {
        this.isLoading = true;
        let _this = this;
        let updateAPriceCategory = new UpdateAPriceCategory(_this);
        updateAPriceCategory.setRequestParamDataObj(_this.defaultPriceCategory);
        await updateAPriceCategory.fetch(async (res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ثبت شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "گروه‌بندی با موفقیت ویرایش شد.",
              },
            });
            await _this.getASinglePriceCategory();
            _this.getPriceCategoryMasters();
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "مشکلی پیش آمد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "لطفا دوباره تلاش کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    titleState() {
      if (this.defaultPriceCategory) {
        if (
          this.defaultPriceCategory.title &&
          this.defaultPriceCategory.title.length <= 200
        ) {
          return true;
        } else if (
          (this.defaultPriceCategory.title &&
            this.defaultPriceCategory.title.length > 200) ||
          this.defaultPriceCategory.title == ""
        ) {
          return false;
        } else {
          return null;
        }
      }
    },
    titleError() {
      if (this.defaultPriceCategory) {
        if (
          this.defaultPriceCategory.title != null &&
          this.defaultPriceCategory.title == ""
        ) {
          return "فیلد عنوان نباید خالی باشد";
        } else if (
          this.defaultPriceCategory.title &&
          this.defaultPriceCategory.title.length > 200
        ) {
          return "متن عنوان نباید بیشتر از 200 کاراکتر باشد";
        }
      }
    },

    durationState() {
      if (this.defaultPriceCategory) {
        if (
          this.defaultPriceCategory.duration == "" ||
          this.defaultPriceCategory.duration < 10 ||
          this.defaultPriceCategory.duration > 120
        ) {
          return false;
        } else if (
          this.defaultPriceCategory.duration &&
          this.defaultPriceCategory.duration >= 10 &&
          this.defaultPriceCategory.duration <= 120
        ) {
          return true;
        } else {
          return null;
        }
      }
    },
    durationError() {
      if (this.defaultPriceCategory) {
        if (
          this.defaultPriceCategory.duration != null &&
          this.defaultPriceCategory.duration == ""
        ) {
          return "فیلد مدت زمان اجباری است";
        } else if (
          this.defaultPriceCategory.duration &&
          this.defaultPriceCategory.duration < 10
        ) {
          return "مدت زمان نباید کمتر از 10 دقیقه باشد";
        } else if (
          this.defaultPriceCategory.duration &&
          this.defaultPriceCategory.duration > 120
        ) {
          return "مدت زمان نباید بیشتر از 120 دقیقه باشد";
        }
      }
    },

    userPriceState() {
      if (this.defaultPriceCategory) {
        if (
          this.defaultPriceCategory.userPrice != null &&
          (this.defaultPriceCategory.userPrice == "" ||
            this.defaultPriceCategory.userPrice < 1000)
        ) {
          return false;
        } else if (
          this.defaultPriceCategory.userPrice &&
          this.defaultPriceCategory.userPrice >= 1000
        ) {
          return true;
        } else if (this.defaultPriceCategory.userPrice == null) {
          return null;
        }
      }
    },
    userPriceError() {
      if (this.defaultPriceCategory) {
        if (
          this.defaultPriceCategory.userPrice != null &&
          this.defaultPriceCategory.userPrice == ""
        ) {
          return "فیلد قیمت پایه زبان آموز اجباری است";
        } else if (
          this.defaultPriceCategory.userPrice &&
          this.defaultPriceCategory.userPrice < 1000
        ) {
          return "قیمت پایه زبان آموز نباید کمتر از 1000 تومان باشد";
        }
      }
    },

    userVipPriceState() {
      if (
        this.defaultPriceCategory.vipUserBasePaymentPrice &&
        this.defaultPriceCategory.vipUserBasePaymentPrice < 1000
      ) {
        return false;
      } else if (
        this.defaultPriceCategory.vipUserBasePaymentPrice &&
        this.defaultPriceCategory.vipUserBasePaymentPrice >= 1000
      ) {
        return true;
      } else if (this.defaultPriceCategory.vipUserBasePaymentPrice == null) {
        return null;
      }
    },

    userVipPriceError() {
      if (
        this.defaultPriceCategory.vipUserBasePaymentPrice &&
        this.defaultPriceCategory.vipUserBasePaymentPrice < 1000
      ) {
        return "قیمت پایه VIP زبان آموز نباید کمتر از 1000 تومان باشد";
      }
    },

    masterVipPriceState() {
      if (
        this.defaultPriceCategory.vipMasterBasePaymentPrice &&
        this.defaultPriceCategory.vipMasterBasePaymentPrice < 1000
      ) {
        return false;
      } else if (
        this.defaultPriceCategory.vipMasterBasePaymentPrice &&
        this.defaultPriceCategory.vipMasterBasePaymentPrice >= 1000
      ) {
        return true;
      } else if (this.defaultPriceCategory.vipMasterBasePaymentPrice == null) {
        return null;
      }
    },
    masterVipPriceError() {
      if (
        this.defaultPriceCategory.vipMasterBasePaymentPrice &&
        this.defaultPriceCategory.vipMasterBasePaymentPrice < 1000
      ) {
        return "قیمت پایه VIP استاد نباید کمتر از 1000 تومان باشد";
      }
    },

    masterPriceState() {
      if (this.defaultPriceCategory) {
        if (
          this.defaultPriceCategory.masterPrice != null &&
          (this.defaultPriceCategory.masterPrice == "" ||
            this.defaultPriceCategory.masterPrice < 1000)
        ) {
          return false;
        } else if (
          this.defaultPriceCategory.masterPrice &&
          this.defaultPriceCategory.masterPrice >= 1000
        ) {
          return true;
        } else if (this.defaultPriceCategory.masterPrice == null) {
          return null;
        }
      }
    },
    masterPriceError() {
      if (this.defaultPriceCategory) {
        if (
          this.defaultPriceCategory.masterPrice != null &&
          this.defaultPriceCategory.masterPrice == ""
        ) {
          return "فیلد قیمت پایه استاد اجباری است";
        } else if (
          this.defaultPriceCategory.masterPrice &&
          this.defaultPriceCategory.masterPrice < 1000
        ) {
          return "قیمت پایه استاد نباید کمتر از 1000 تومان باشد";
        }
      }
    },

    descriptionState() {
      if (this.defaultPriceCategory) {
        if (
          this.defaultPriceCategory.description != null &&
          (this.defaultPriceCategory.description == "" ||
            this.defaultPriceCategory.description.length > 4000)
        ) {
          return false;
        } else if (
          this.defaultPriceCategory.description &&
          this.defaultPriceCategory.description.length <= 4000
        ) {
          return true;
        } else if (this.defaultPriceCategory.description == null) {
          return null;
        }
      }
    },
    descriptionError() {
      if (this.defaultPriceCategory) {
        if (
          this.defaultPriceCategory.description != null &&
          this.defaultPriceCategory.description == ""
        ) {
          return "فیلد توضیحات گروه‌بندی اجباری است";
        } else if (
          this.defaultPriceCategory.description &&
          this.defaultPriceCategory.description.length > 4000
        ) {
          return "توضیحات گروه‌بندی نباید بیشتر از 4000 کاراکتر باشد";
        }
      }
    },

    isSubmitButtonDisabled() {
      if (
        this.descriptionState &&
        this.masterPriceState &&
        this.userPriceState &&
        this.durationState &&
        this.titleState
      ) {
        return false;
      }
      return true;
    },
  },
  components: {
    PageWrapper,
    BCard,
    BRow,
    BCol,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BButton,
    BFormTextarea,
    BOverlay,
    BFormInvalidFeedback,
    LanguagePicker,
    MasterPicker,
    PriceCategoryPicker,
    BInputGroup,
    DaysLimitPicker,
  },
};
import {
  GetASinglePriceCategory,
  UpdateAPriceCategory,
  AddUserToPriceCategory,
  GetPriceCategoryUsers,
} from "@/libs/Api/PriceCategory";
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import LanguagePicker from "@/views/components/Language/LanguagePicker.vue";
import MasterPicker from "@/views/components/MasterActiveCourse/MasterPicker.vue";
import PriceCategoryPicker from "@/views/apps/PriceCategory/PriceCategoryPicker.vue";
import DaysLimitPicker from "@/views/components/PriceCategory/DaysLimitPicker.vue";
import {
  BCard,
  BRow,
  BCol,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BButton,
  BFormTextarea,
  BOverlay,
  BFormInvalidFeedback,
  BInputGroup,
} from "bootstrap-vue";
</script>
